import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'wouter';

import { FullPageLoader } from '@/components/feedback/full-page-loader';
import { ErrorState } from '@/components/feedback/error-state';
import { useAuth } from '@/contexts/auth-context';
function SessionUnavailable() {
  const { retrySession } = useAuth();
  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <div className="max-w-md rounded-xl border p-5">
        <h1 className="mb-3 font-semibold">Não foi possível restaurar sua sessão</h1>
        <p className="mb-3 text-sm">
          Uma falha temporária ou limite de requisições não significa que sua sessão foi revogada.
          Aguarde e tente novamente.
        </p>
        <ErrorState onRetry={() => void retrySession()} />
      </div>
    </main>
  );
}

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const [, navigate] = useLocation();
  useEffect(() => {
    if (status === 'anonymous') navigate('/login', { replace: true });
  }, [navigate, status]);
  if (status === 'error') return <SessionUnavailable />;
  if (status !== 'authenticated') return <FullPageLoader />;
  return children;
}

export function PlatformAdminRoute({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  const [, navigate] = useLocation();
  useEffect(() => {
    if (status === 'anonymous') navigate('/login', { replace: true });
    if (status === 'authenticated' && !user?.isPlatformAdmin) navigate('/app', { replace: true });
  }, [navigate, status, user?.isPlatformAdmin]);
  if (status === 'error') return <SessionUnavailable />;
  if (status !== 'authenticated' || !user?.isPlatformAdmin) return <FullPageLoader />;
  return children;
}

export function OwnerRoute({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  const [, navigate] = useLocation();
  useEffect(() => {
    if (status === 'anonymous') navigate('/login', { replace: true });
    if (status === 'authenticated' && user?.role !== 'OWNER') navigate('/app', { replace: true });
  }, [navigate, status, user?.role]);
  if (status === 'error') return <SessionUnavailable />;
  if (status !== 'authenticated' || user?.role !== 'OWNER') return <FullPageLoader />;
  return children;
}
